// extracted by mini-css-extract-plugin
export default {"key-id":"knuXYwOZ7B","keyId":"knuXYwOZ7B","right-tag":"_2sm80XNYLN","rightTag":"_2sm80XNYLN"};